// extracted by mini-css-extract-plugin
export var dataCell = "_lq-2";
export var dataRow = "_lq-0";
export var headerRow = "_lq-1";